'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterLink = undefined;

var _immutable = require('immutable');

/** FooterLink model */


/** Exported types */
var FooterLink = exports.FooterLink = (0, _immutable.Record)({
    id: 0,
    title: '',
    url: '',
    target: '_self',
    nofollow: true,
    isFooter: true,
    isHamburger: false,
    hamburgerParent: '',
    className: ''
});

/**
 * Converts a single footerLink to a data model
 * @param {PlatformType} platform The platform to get the footerLinks for
 * @returns {function(FooterLinkListType, SquizFooterLinkType)} A function which adds the passed footerLink
 * to the accumulator list
 */

var footerLinkToDataModel = function footerLinkToDataModel(platform) {
    return function (bag, footerLink) {
        var _footerLink$link$plat = footerLink.link[platform],
            url = _footerLink$link$plat.url,
            enabled = _footerLink$link$plat.enabled,
            target = _footerLink$link$plat.target,
            _footerLink$link$plat2 = _footerLink$link$plat.nofollow,
            nofollow = _footerLink$link$plat2 === undefined ? true : _footerLink$link$plat2,
            _footerLink$link$plat3 = _footerLink$link$plat.className,
            className = _footerLink$link$plat3 === undefined ? '' : _footerLink$link$plat3;
        var id = footerLink.id,
            title = footerLink.title,
            _footerLink$sectionVi = footerLink.sectionVisibility,
            sectionVisibility = _footerLink$sectionVi === undefined ? {} : _footerLink$sectionVi,
            hamburgerParent = footerLink.hamburgerParent;


        if (enabled) {
            return bag.push(new FooterLink({
                id: id,
                title: title,
                url: url,
                target: target,
                nofollow: nofollow,
                isFooter: sectionVisibility.footer,
                isHamburger: sectionVisibility.hamburger,
                hamburgerParent: hamburgerParent,
                className: className
            }));
        }
        return bag;
    };
};

/**
 * Wrapper function to get platform parameter in scope
 * @param {Array<SquizFooterLinkType>} footerLinks An array of footerLinks as returnd by Squiz
 * @param {PlatformType} platform The platform that was requested
 * @returns {FooterLinkListType} An immutable list of FooterLink Records
 */
var transformFooterLinkData = function transformFooterLinkData(footerLinks) {
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mobile';

    if (footerLinks.data) {
        return footerLinks.data.reduce(footerLinkToDataModel(platform), (0, _immutable.List)());
    }

    return (0, _immutable.List)();
};

exports.default = transformFooterLinkData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/footer-links/model.js
// module id = 253
// module chunks = 0